import React from 'react';
import Icon from '../../../components/AppIcon';

const PortfolioSummaryCards = ({ portfolioMetrics }) => {
  const summaryCards = [
    {
      title: 'Total Portfolio Value',
      value: portfolioMetrics?.totalValue,
      change: portfolioMetrics?.valueChange,
      changeType: portfolioMetrics?.valueChange >= 0 ? 'positive' : 'negative',
      icon: 'DollarSign',
      color: 'text-primary'
    },
    {
      title: 'Average LTV',
      value: `${portfolioMetrics?.averageLTV}%`,
      change: portfolioMetrics?.ltvChange,
      changeType: portfolioMetrics?.ltvChange <= 0 ? 'positive' : 'negative',
      icon: 'TrendingUp',
      color: 'text-accent'
    },
    {
      title: 'High Risk Assets',
      value: portfolioMetrics?.highRiskCount,
      change: portfolioMetrics?.riskChange,
      changeType: portfolioMetrics?.riskChange <= 0 ? 'positive' : 'negative',
      icon: 'AlertTriangle',
      color: 'text-destructive'
    },
    {
      title: 'Pending Valuations',
      value: portfolioMetrics?.pendingValuations,
      change: null,
      changeType: 'neutral',
      icon: 'Clock',
      color: 'text-warning'
    }
  ];

  const formatChange = (change, changeType) => {
    if (change === null) return null;
    
    const sign = change >= 0 ? '+' : '';
    const colorClass = changeType === 'positive' ? 'text-success' : 'text-destructive';
    const icon = changeType === 'positive' ? 'TrendingUp' : 'TrendingDown';
    
    return (
      <div className={`flex items-center space-x-1 ${colorClass}`}>
        <Icon name={icon} size={12} />
        <span className="text-xs font-medium">{sign}{change}%</span>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {summaryCards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 shadow-card">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-2 rounded-lg bg-muted ${card?.color}`}>
              <Icon name={card?.icon} size={20} />
            </div>
            {formatChange(card?.change, card?.changeType)}
          </div>
          
          <div>
            <h3 className="text-2xl font-semibold text-text-primary mb-1">
              {card?.value}
            </h3>
            <p className="text-sm text-text-secondary">{card?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PortfolioSummaryCards;